import consumer from '../channels/consumer';
import ApplicationController from './application_controller';
import { Modal } from 'bootstrap';

const CHANNEL_NAME = 'PurchaseChannel';
const ERROR_MESSAGES = {
  failed_reservation: 'No se pudo completar la compra.',
  failed_payment: 'Se intentó completar la compra pero hubo un error con el pago.',
  failed_update: 'No se pudo actualizar la compra.',
  failed_cancellation: 'Se intentó cancelar el movimiento pero hubo un error.',
};
// Defines transporter abbreviations that require the purchaser data update modal
// when the current tenant is Reservamos
const MODAL_PURCHASER_TRANSPORTERS = ['gfa', 'ttur', 'coord'];

export default class extends ApplicationController {
  static targets = ['container', 'spinner', 'formModal'];
  modal = null;
  confirmUrl = null;
  confirmMethod = 'put';
  triggerElement = null;
  isReservamosTenant = false;
  transporterAbbrs = [];
  modalHiddenHandler = null;

  connect() {
    this.isReservamosTenant = this.data.get('isReservamosTenant') === 'true';
    try {
      this.transporterAbbrs = JSON.parse(this.data.get('transporterAbbrs') || '[]');
    } catch (e) {
      console.error("Error parsing transporter abbreviations:", e);
      this.transporterAbbrs = [];
    }

    this.subscribe(this.purchaseId);
    if (this.hasFormModalTarget) {
      this.modal = new Modal(this.formModalTarget);
      this.modalHiddenHandler = this.handleModalHidden.bind(this);
      this.formModalTarget.addEventListener('hidden.bs.modal', this.modalHiddenHandler);
    }
  }

  disconnect() {
    if (this.modal) {
      this.modal.dispose();
    }
    if (this.hasFormModalTarget && this.modalHiddenHandler) {
      this.formModalTarget.removeEventListener('hidden.bs.modal', this.modalHiddenHandler);
    }
  }

  subscribe(purchaseId) {
    consumer.subscriptions.create(
      {
        channel: CHANNEL_NAME,
        purchase_id: purchaseId,
      },
      {
        connected() {
          console.log('connected_to_purchase_channel', purchaseId);
        },

        received(data) {
          console.log(`Data received from ${CHANNEL_NAME}`, data);

          if (data.state == 'finished') {
            window.location.reload();
            return;
          }

          if (!ERROR_MESSAGES[data.state]) {
            return;
          }

          alert(ERROR_MESSAGES[data.state]);
          window.location.reload();
        },
      }
    );
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.confirmUrl = event.currentTarget.href;
    this.confirmMethod = event.currentTarget.dataset.method || 'put';
    this.triggerElement = event.currentTarget;

    const involvesSpecialTransporter = this.transporterAbbrs.some(abbr => MODAL_PURCHASER_TRANSPORTERS.includes(abbr));
    const requireForm = this.isReservamosTenant && involvesSpecialTransporter;

    if (requireForm && this.modal) {
      this.modal.show();
    } else if (requireForm && !this.modal) {
      console.error("Form required but modal target not found or Bootstrap modal not initialized.");
      alert("An error occurred. Please try again.");
    } else {
      this.proceedWithAction();
    }
  }

  submitForm(event) {
    event.preventDefault();
    const form = event.target;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);

    // Note: If you need to add extra data not in the form, you can append it:
    // formData.append('extra_param', 'some_value');
    if (this.modal) {
      this.modal.hide();
    }

    this.proceedWithAction(formData);
  }

  cancelForm() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (this.modal) {
      this.modal.hide();
    }
    console.log("Payment completion cancelled by user.");
  }

  handleModalHidden() {
    if (this.triggerElement) {
      const trigger = this.triggerElement;
      requestAnimationFrame(() => {
          try {
              trigger.focus();
          } catch (e) {
              console.error("Error focusing trigger element:", e);
          }
      });
    }
    this.triggerElement = null;
    this.confirmUrl = null;
  }

  proceedWithAction(formData = null) {
    this.insertTemplate(this.spinnerTarget, this.containerTarget);

    if (this.confirmUrl) {
      const fetchOptions = {
          method: this.confirmMethod.toUpperCase(),
          headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          },
      };

      if (formData) {
        fetchOptions.body = formData;
      }

      fetch(this.confirmUrl, fetchOptions).then(response => {
        if (!response.ok) {
          console.error("Request failed:", response.statusText);
          alert("Error initiating action. Please try again.");
          window.location.reload();
        }
      }).catch(error => {
          console.error("Request error:", error);
          alert("Error initiating action. Please try again.");
          window.location.reload();
      });
    } else {
      console.error("No confirmation URL stored.");
      this.containerTarget.innerHTML = "Error: No action URL.";
    }
  }

  get purchaseId() {
    return this.data.get('purchaseId');
  }
}
